// extracted by mini-css-extract-plugin
export default {"overlay":"ModalWindow_overlay__IkPuT","content":"ModalWindow_content__4bYSW"};